export const paths = {
  myAgent: () => '/my-agent',
}
